import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MasterService } from '../../@core/services/master.service';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { DatePipe } from '@angular/common';
import { NotificationService } from '../../@core/services/notification.service';
import { NbToastrService } from '@nebular/theme';
import { MenuService } from '../pages-menu';
declare var $: any;

@Component({
  selector: 'ngx-dashboard-manager',
  templateUrl: './dashboard-manager.component.html',
  styleUrls: ['./dashboard-manager.component.scss']
})
export class DashboardManagerComponent implements OnInit {
  form!: FormGroup;
  projectForm!: FormGroup;
  currentPage: number = 1;
  itemsPerPage: number = 10;
  paginateData: any;
  firstItemIndex: number = 1;
  lastItemIndex: number = 0;
  tableDataLength: number = 0;
  paginationData: any;
  searchInput: any = '';
  // selectedCustomerName: any = "";
  selectedEngineer: any = "";
  selectedCurrentStage: any = "";
  selectedRfqDate: any = "";
  fromRfqDate: any = '';
  toRfqDate: any = '';
  showModalECD: boolean = false; // ECD modal visibility flag
  showModalRFQ: boolean = false; // RFQ modal visibility flag
paginatestartIndex:number = 0
  paginateendIndex:number = 10
  fromExpectedCompletionDate: any = '';
  toExpectedCompletionDate: any = '';
  selectedExpetedCompletionDate: any = "";
  matchedCustomerData: any[] = []; // To store the matching result
  matchedProjectData: any[] = []; // To store the matching result
  modalRef: NgbModalRef | null = null;
  selectedCustomerName: string = '';
  selectedProjectName: string = '';
  searchText: string = '';
  showAddCustomerButton: boolean = false;
  allCustomerData: any[] = [];
  isProjectNameDuplicate: boolean = false;
  isRefresh: boolean = false;
  selectedVersionId: any = null;
  showDutyInput: boolean = false;
  fromAnalysisManager: boolean = false;
  showProjectDropdown: boolean = false;
  filteredProjectNames: string[] = [];
  selectedApprovalProject: any = null;
  approvalReviewComments: string = '';
  projectStatuses: any[] = [];
  selectedApprovalStatus: string = 'Approved';
  showReworkCommentBox: boolean = false;
  isApprovalSubmitting: boolean = false;
  // onQn123: any = {
  //   q1: false, q2: false, q3: false,
  // }
  // allCustomerData = [
  //   {
  //     serialNumber: 100001,
  //     customerName: "John Doe",
  //     city: "New York",
  //     state: "NY",
  //     country: "USA",
  //     gstNumber: "GST12345",
  //     createdBy: "Admin",
  //     createdOn: "2024-10-01",
  //     lastModifiedBy: "Admin",
  //     lastModifiedOn: "2024-11-01",
  //     activeStatus: true,
  //   },
  //   {
  //     serialNumber: 100002,
  //     customerName: "Jane Smith",
  //     city: "Los Angeles",
  //     state: "CA",
  //     country: "USA",
  //     gstNumber: "GST67890",
  //     createdBy: "Manager",
  //     createdOn: "2024-09-15",
  //     lastModifiedBy: "Supervisor",
  //     lastModifiedOn: "2024-10-20",
  //     activeStatus: false,
  //   },
  //   {
  //     serialNumber: 100003,
  //     customerName: "Michael Johnson",
  //     city: "Chicago",
  //     state: "IL",
  //     country: "USA",
  //     gstNumber: "GST24680",
  //     createdBy: "Staff",
  //     createdOn: "2024-08-10",
  //     lastModifiedBy: "Admin",
  //     lastModifiedOn: "2024-09-05",
  //     activeStatus: true,
  //   },
  //   {
  //     serialNumber: 100004,
  //     customerName: "Emily Davis",
  //     city: "Houston",
  //     state: "TX",
  //     country: "USA",
  //     gstNumber: "GST13579",
  //     createdBy: "Admin",
  //     createdOn: "2024-07-20",
  //     lastModifiedBy: "Manager",
  //     lastModifiedOn: "2024-09-25",
  //     activeStatus: false,
  //   },
  //   {
  //     serialNumber: 100005,
  //     customerName: "Chris Wilson",
  //     city: "Phoenix",
  //     state: "AZ",
  //     country: "USA",
  //     gstNumber: "GST98765",
  //     createdBy: "Manager",
  //     createdOn: "2024-11-10",
  //     lastModifiedBy: "Supervisor",
  //     lastModifiedOn: "2024-11-12",
  //     activeStatus: true,
  //   },
  //   {
  //     serialNumber: 100006,
  //     customerName: "Chris Wilson",
  //     city: "Phoenix",
  //     state: "AZ",
  //     country: "USA",
  //     gstNumber: "GST98765",
  //     createdBy: "Manager",
  //     createdOn: "2024-11-10",
  //     lastModifiedBy: "Supervisor",
  //     lastModifiedOn: "2024-11-12",
  //     activeStatus: false,
  //   },
  // ];
  engineersData = [];
  thisMonthProjects: any[] = [];
  // allCustomerData = [
  //   {
  //     serialNumber: 1,
  //     projectName: "Project Alpha",
  //     customerName: "Customer A",
  //     rfqDate: new Date("2024-01-15"),
  //     assignedTo: "John Doe",
  //     assignedDate: new Date("2024-01-20"),
  //     expetedCompletionDate: new Date("2024-02-15"),
  //     targetLeadTime: "4 weeks",
  //     ageing: "2 weeks",
  //     progress: "50",
  //     status: "In Progress",
  //     currentStage: "procurement",
  //     activeStatus: true
  //   },
  //   {
  //     serialNumber: 2,
  //     projectName: "Project Beta",
  //     customerName: "Customer B",
  //     rfqDate: new Date("2024-02-01"),
  //     assignedTo: "Jane Smith",
  //     assignedDate: new Date("2024-02-05"),
  //     expetedCompletionDate: new Date("2024-03-01"),
  //     targetLeadTime: "3 weeks",
  //     ageing: "1 week",
  //     progress: "30",
  //     status: "In Progress",
  //     currentStage: "Costing",
  //     activeStatus: false
  //   },
  //   {
  //     serialNumber: 3,
  //     projectName: "Project Gamma",
  //     customerName: "Customer C",
  //     rfqDate: new Date("2024-01-10"),
  //     assignedTo: "Alice Johnson",
  //     assignedDate: new Date("2024-01-12"),
  //     expetedCompletionDate: new Date("2024-02-10"),
  //     targetLeadTime: "6 weeks",
  //     ageing: "4 weeks",
  //     progress: "70",
  //     status: "On Hold",
  //     currentStage: "Costing",
  //     activeStatus: true
  //   },
  //   {
  //     serialNumber: 4,
  //     projectName: "Project Delta",
  //     customerName: "Customer E",
  //     rfqDate: new Date("2024-01-25"),
  //     assignedTo: "Bob Williams",
  //     assignedDate: new Date("2024-01-30"),
  //     expetedCompletionDate: new Date("2024-03-05"),
  //     targetLeadTime: "5 weeks",
  //     ageing: "3 weeks",
  //     progress: "20",
  //     status: "Delayed",
  //     currentStage: "procurement",
  //     activeStatus: false
  //   },
  //   {
  //     serialNumber: 5,
  //     projectName: "Project Epsilon",
  //     customerName: "Customer E",
  //     rfqDate: new Date("2024-02-10"),
  //     assignedTo: "Chris Brown",
  //     assignedDate: new Date("2024-02-15"),
  //     expetedCompletionDate: new Date("2024-03-15"),
  //     targetLeadTime: "4 weeks",
  //     ageing: "2 weeks",
  //     progress: "90",
  //     status: "Not Started",
  //     currentStage: "Costing",
  //     activeStatus: true
  //   },
  //   {
  //     serialNumber: 6,
  //     projectName: "Project E",
  //     customerName: "Customer E",
  //     rfqDate: new Date("2024-02-10"),
  //     assignedTo: "Chris Brown",
  //     assignedDate: new Date("2024-02-15"),
  //     expetedCompletionDate: new Date("2024-03-15"),
  //     targetLeadTime: "4 weeks",
  //     ageing: "2 weeks",
  //     progress: "20%",
  //     status: "Open",
  //     currentStage: "Costing",
  //     activeStatus: true,
  //     version: 'Version 2'
  //   },
  //   {
  //     serialNumber: 7,
  //     projectName: "Project M",
  //     customerName: "Customer M",
  //     rfqDate: new Date("2024-02-10"),
  //     assignedTo: "Chris Brown",
  //     assignedDate: new Date("2024-04-15"),
  //     expetedCompletionDate: new Date("2024-06-15"),
  //     targetLeadTime: "4 weeks",
  //     ageing: "2 weeks",
  //     progress: "30%",
  //     status: "Open",
  //     currentStage: "Costing",
  //     activeStatus: true,
  //     version: 'Version 2'
  //   },
  //   {
  //     serialNumber: 8,
  //     projectName: "Project M",
  //     customerName: "Customer OR",
  //     rfqDate: new Date("2024-08-10"),
  //     assignedTo: "Chris Brown",
  //     assignedDate: new Date("2024-02-15"),
  //     expetedCompletionDate: new Date("2024-12-15"),
  //     targetLeadTime: "12 weeks",
  //     ageing: "1 weeks",
  //     progress: "40%",
  //     status: "Open",
  //     currentStage: "Costing",
  //     activeStatus: true,
  //     version: 'Version 2'
  //   }
  // ];


  // pageSize: number;
  addtionalChargesDetails = [];
  downloadData = [];
  closeResult: string = '';
  isSaving: any;
  customerForm: any;
  allCustomerDetails: any[] = [];
  rawApiCustomers: any[] = [];
  customerModalRef: any = null;
  userId!: number;
  role: any;
  selectedCustomerId: any;
  currentDate: any;
  assignDate: any;
  projectsData: any;
  editingRowId: number | null = null;
  openStatusCount!: number;
  overdueCount!: number;


  changedstage: any;
  allProjectDetails = [];
  selectedProjectId: any;
  isCustomerNameDuplicate: boolean = false;
  selectedAssigned_to_id: any;
  // selectedCurrentstage: any;
  selectedmatchedCustomerData: any;
  projectNameDetails: any[] = [];
  allOpenProjectDetails: any;
  groupedProjectData: any[] = [];
  currentPageIndex: number = 0;

  rowsPerPage: number | string = 10;

  paginatedData: any[] = [];
  // rowsPerPage = 10; 
  pageSizeOptions: (number | string)[] = [10, 20, 50, 100, 'All'];

  // ========== TAB-RELATED PROPERTIES ==========
  activeTab: number = 1; // Track the active tab (1 = Costing, 2 = Procurement)
  
  // Filtered data for each tab
  costingData: any[] = [];
  procurementData: any[] = [];
  currentTabData: any[] = []; // Data to display based on active tab
  
  // Pagination for each tab
  costingCurrentPage: number = 1;
  procurementCurrentPage: number = 1;
  costingRowsPerPage: any = 10;
  procurementRowsPerPage: any = 10;
  costingTotalCount: number = 0;
  procurementTotalCount: number = 0;
  totalProjectsCount: number = 0;
  jumpPageInput: string = '';
  
  // State persistence for navigation
  highlightedProjectId: any = null; // Store project ID for row highlighting
  restoredState: boolean = false; // Flag to prevent multiple restorations
  statusFilter: string | null = null;
  allCostingProjects: any[] = [];
  allProcurementProjects: any[] = [];

  maxToday: string = '';

  nextMaxDate: string = '';
  isExpectedCompletionDateDisabled: boolean = true;
  onQn123:any = {
    q1: null,  // Landing cost
    q2: null,  // Duties
    q3: null   // Duty Value
  };

  dutyValuePercentage: number = 0;





  constructor(private f_builder: FormBuilder,
    private router: Router,
    private modalService: NgbModal,
    private masterService: MasterService,
    private menuService: MenuService,
    private datePipe: DatePipe,
    private notify: NbToastrService,
    private cdRef: ChangeDetectorRef
  ) {

    const now = new Date();
    // this.currentDate = now.toISOString(); 
    this.currentDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.assignDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');


  }

  loadProjectStatuses(): void {
    this.masterService.getProjectStatuses().subscribe({
      next: (res: any) => {
        if (res && res.data) {
          this.projectStatuses = res.data;
        }
      },
      error: (err: any) => {
        console.error('Error loading project statuses:', err);
      }
    });
  }

  ngOnInit(): void {
    this.loadProjectStatuses();
    this.role = ''
    this.userId = Number(sessionStorage.getItem('user_id'));
    this.role = sessionStorage.getItem('role');

    // Check if coming from analysis-manager
    const navigationState = history.state;
    if (navigationState?.fromAnalysisManager) {
      this.fromAnalysisManager = true;
      console.log("📍 Arrived from Analysis Manager");
    }

    this.projectForm = this.f_builder.group({
      newProjectName: ['', Validators.required],
      projectNo: ['', ],
      description: ['', ],
      customerFullName: ['', Validators.required],
      rfqDate: ['', Validators.required],
      completionDate: ['', Validators.required],
      targetLT: ['', Validators.required],
      assignTo: ['', Validators.required],
      currentStage: ['', Validators.required],
      version_id: [{ value: 1, disable: true }, Validators.required]
    });

    this.customerForm = this.f_builder.group({
      _customerFullName: ['', [Validators.required, Validators.minLength(2)]],
      city: ['', Validators.required],
      state: ['', Validators.required],
      country: ['', Validators.required],
      gstNumber: ['', [Validators.required]],
    });

    const currentDate = new Date();
    const istDate = new Date(currentDate.getTime() + (5.5 * 60 * 60 * 1000));
    this.maxToday = istDate.toISOString().split('T')[0];
    const nextDay = new Date(istDate);
    nextDay.setUTCDate(nextDay.getUTCDate() + 1);
    this.nextMaxDate = nextDay.toISOString().split('T')[0];

    this.projectForm.get('currentStage')?.valueChanges.subscribe(newStage => {
      if (this.previousStage === 'Costing' && newStage === 'Procurement') {
        console.log("Stage changed: Costing → Procurement");
        this.keepLandingCostValues();
      }
    });

    // ⚡ Load data immediately
    this.getAllcustomers();
    this.getdata();
    this.fetchStageCounts();
    
    // Check navigation state to determine which tab to load
    const navState = history.state;
    if (navState?.activeTab) {
      this.loadBothStages(() => {
        this.restoreNavigationState(navState);
      });
    } else {
      this.loadBothStages();
    }
  }

  receiveData(){
    const navigationState = history.state;
    
    if(navigationState && Object.keys(navigationState).length > 0){
      // ⚡ Restore tab state if coming from Project View
      if(navigationState.hasOwnProperty('activeTab')){
        console.log('🔄 Restoring navigation state from Project View');
        this.restoreNavigationState(navigationState);
      }
      
      // ⚡ Apply rows per page if provided
      if(navigationState.hasOwnProperty('rowsPerPage')){
        this.rowsPerPage = navigationState.rowsPerPage || 10;
      }
      
      // ⚡ Apply current page if provided
      if(navigationState.hasOwnProperty('currentPage')){
        this.currentPage = navigationState.currentPage || 1;
        this.paginate();
      }
      
      // ⚡ Handle filter from analysis-manager for open projects
      if(navigationState.hasOwnProperty('filterType') && navigationState.filterType === 'open'){
        console.log('🔵 Filtering for Open projects immediately');
        this.onOpenClickedProject(navigationState.filterStatus || 'Open');
      }
      
      // ⚡ Handle filter from analysis-manager to show all projects
      if(navigationState.hasOwnProperty('filterType') && navigationState.filterType === 'all'){
        console.log('📊 Showing all projects');
        this.groupedProjectData = this.originalGroupedData;
        this.updateTableRows();
      }
      
      // ⚡ Handle filter from analysis-manager for completion percentage
      if(navigationState.hasOwnProperty('filterType') && navigationState.filterType === 'completion'){
        console.log('📈 Filtering by completion:', navigationState.completionRange);
        this.onCompletionFilterClicked(navigationState.completionRange);
      }
    }
    
    history.replaceState({}, '');
  }
  today: Date = new Date();
  isECDGreaterThanToday(dateString: string | Date): boolean {
  if (!dateString) return false;
  const today = new Date();
  const ecdDate = new Date(dateString);
  return ecdDate < today;
}
keepLandingCostValues() {
  // Keep values AS IS – don't modify them
  console.log("Keeping previous Landing Cost values:", this.onQn123, this.dutyValuePercentage);
}



  calculateAgeing(assignedDate: string, status: string, closedDate?: string): number {
    const assignedDateObj = new Date(assignedDate);
    let endDate = new Date();

    if (status === 'Closed' && closedDate) {
      endDate = new Date(closedDate);
    }

    const timeDifference = endDate.getTime() - assignedDateObj.getTime();
    return Math.floor(timeDifference / (1000 * 3600 * 24));
  }

  filterProjectNames() {
    const input = (this.selectedProjectName || '').toLowerCase().trim();
    if (input) {
      this.filteredProjectNames = this.projectNameDetails.filter(name =>
        name && name.toLowerCase().includes(input)
      );
    } else {
      this.filteredProjectNames = [...this.projectNameDetails];
    }
    this.showProjectDropdown = true;
    this.applyAllFilters();
  }

  selectProjectName(name: string) {
    this.selectedProjectName = name;
    this.showProjectDropdown = false;
    this.applyAllFilters();
  }

  onProjectFocus() {
    this.showProjectDropdown = true;
    const input = (this.selectedProjectName || '').toLowerCase().trim();
    if (input) {
      this.filteredProjectNames = this.projectNameDetails.filter(name =>
        name && name.toLowerCase().includes(input)
      );
    } else {
      this.filteredProjectNames = [...this.projectNameDetails];
    }
  }

  onProjectEnter() {
    this.showProjectDropdown = false;
    this.applyAllFilters();
  }

  hideDropdown() {
    setTimeout(() => {
      this.showProjectDropdown = false;
    }, 250);
  }

  updateCardCounts(): void {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Use base data for card counts
    const dataToCount = this.getBaseProjectsForActiveTab();

    this.openStatusCount = dataToCount.filter(
      group => group.selectedVersionData?.status === 'Open' || 
               group.selectedVersionData?.status === 'In Progress' ||
               group.status === 'Open' ||
               group.status === 'In Progress'
    ).length;

    this.overdueCount = dataToCount.filter(group => {
      const ecd = group.selectedVersionData?.expectedCompletionDate || group.expectedCompletionDate;
      if (!ecd) return false;
      const expectedDate = new Date(ecd);
      expectedDate.setHours(0, 0, 0, 0);
      const st = group.selectedVersionData?.status || group.status;
      return expectedDate < today && st === 'Open';
    }).length;

    this.getThisMonthProjects();
  }

  updateRfqDate() {
    const startDate = this.projectForm.get('rfqDate')?.value;
    if (startDate) {
      let nextDay = new Date(startDate);
      nextDay.setDate(nextDay.getDate() + 1);
      this.nextMaxDate = nextDay.toISOString().split('T')[0];
      this.isExpectedCompletionDateDisabled = false;
      this.projectForm.get('completionDate')?.enable();
    }
    else {
      this.isExpectedCompletionDateDisabled = true;
      this.projectForm.get('completionDate')?.disable();
    }

  }
  updatecompletionDate() {
    const startDate = this.projectForm.get('rfqDate')?.value;
    if (startDate) {

    }
    else {
      this.projectForm.get('completionDate')?.setValue('');
      this.notify.danger('Please Select the RFQ date Before choosing an Expected Completion Date');

    }
  }

  refreshPage() {
    this.isRefresh = true;
    
    // Preserve the current active tab before resetting
    const currentActiveTab = this.activeTab;
    
    // Reset all tab and pagination states to initial values
    this.resetTabsAndPagination();
    
    // Restore the active tab so user stays on the same tab after refresh
    this.activeTab = currentActiveTab;
    
    // Reset all filters
    this.resetAllFilters();
    
    // Reset upload data
    this.resetFinalData();
    
    // Reload data from APIs with the current tab's stage
    const currentStage = this.activeTab === 1 ? 'costing' : 'procurement';
    this.getAllcustomers();
    this.getdata();
    this.fetchStageCounts();
    this.getAllProjectData(currentStage);
  }

  // Reset tabs and pagination to initial state
  private resetTabsAndPagination(): void {
    // Note: activeTab is NOT reset here - caller decides whether to preserve it
    
    // Tab-specific pagination
    this.costingCurrentPage = 1;
    this.procurementCurrentPage = 1;
    this.costingRowsPerPage = 10;
    this.procurementRowsPerPage = 10;
    this.costingTotalCount = 0;
    this.procurementTotalCount = 0;
    
    // General pagination
    this.currentPage = 1;
    this.rowsPerPage = 10;
    this.totalProjectsCount = 0;
    this.paginatestartIndex = 0;
    this.paginateendIndex = 10;
    
    // Tab data
    this.costingData = [];
    this.procurementData = [];
    this.currentTabData = [];
    this.paginatedData = [];
    
    // State persistence
    this.highlightedProjectId = null;
    this.restoredState = false;
    
    console.log('✅ Tabs and pagination reset to initial state');
  }

  // Reset all filter values
  private resetAllFilters(): void {
    this.selectedProjectName = '';
    this.selectedCustomerName = '';
    this.selectedEngineer = '';
    this.selectedCurrentStage = '';
    this.selectedExpetedCompletionDate = '';
    this.selectedRfqDate = '';
    this.fromExpectedCompletionDate = '';
    this.toExpectedCompletionDate = '';
    this.fromRfqDate = '';
    this.toRfqDate = '';
    this.statusFilter = null;
    this.showProjectDropdown = false;
    this.filteredProjectNames = [...this.projectNameDetails];
    
    console.log('✅ All filters reset to initial state');
  }

  // Reset final data (placeholder for dashboard-manager)
  resetFinalData() {
    // Dashboard-manager doesn't have upload functionality like dashboard-engineer
    // This method is kept for consistency with refreshPage() flow
    console.log('✅ Final data reset');
  }

  getdata() {

    let manager_id = {
      'manager_id': Number(this.userId),
    }
    this.masterService.get_manager_and_engineers(manager_id).subscribe((result: any) => {
      let message = result['message'];
      let status = result['status'];
      if (result) {
        // this.engineersData = result['data'];
        let data = result;
        this.engineersData = data.engineers;
        console.log('engineersData', this.engineersData);
        ;
      } else {
        // Handle error if status is not true
        console.error('Error: Unable to retrieve project data');
        // You can also set an error message to display in the UI
        // alert('There was an issue retrieving the project data. Please try again.');
        this.notify.danger('There was an issue retrieving the project data. Please try again.');
      }

    })
  }
  getAllcustomers(callback?: () => void) {
    let cus = {
      "operation_type": "READALL"
    };
    this.masterService.all_customers(cus).subscribe({
      next: (result: any) => {
        if (result) {
          let list: any[] = [];
          if (Array.isArray(result)) {
            list = result;
          } else if (Array.isArray(result.data)) {
            list = result.data;
          } else if (Array.isArray(result.record)) {
            list = result.record;
          } else if (Array.isArray(result.records)) {
            list = result.records;
          } else if (Array.isArray(result.customers)) {
            list = result.customers;
          }
          this.rawApiCustomers = list;
          this.syncCustomerDropdown(list);
          console.log('allCustomerDetails synced =>', this.allCustomerDetails);
        } else {
          console.error('Error: Unable to retrieve Customer data');
          this.notify.danger('There was an issue retrieving the Customer data. Please try again.');
        }
        if (callback) {
          callback();
        }
        this.cdRef.detectChanges();
      },
      error: (err: any) => {
        console.error('Error in all_customers:', err);
        if (callback) {
          callback();
        }
        this.cdRef.detectChanges();
      }
    });
  }

  syncCustomerDropdown(apiCustomers?: any[]): void {
    const customersToProcess = (apiCustomers && apiCustomers.length > 0)
      ? apiCustomers
      : (this.rawApiCustomers && this.rawApiCustomers.length > 0 ? this.rawApiCustomers : []);

    const customerMap = new Map<string, any>();

    // 1. Process API customers
    (customersToProcess || []).forEach(item => {
      const name = item?.customerName || item?.customer_name || item?.['Customer Full name'] || (typeof item === 'string' ? item : '');
      const id = item?.customer_id ?? item?.id ?? null;
      if (name && typeof name === 'string' && name.trim() && name.trim() !== 'N/A') {
        const trimmed = name.trim();
        const key = trimmed.toLowerCase();
        if (!customerMap.has(key)) {
          customerMap.set(key, {
            customerName: trimmed,
            customer_name: trimmed,
            customer_id: id ? Number(id) : null,
            id: id ? Number(id) : null
          });
        } else if (id && !customerMap.get(key).customer_id) {
          customerMap.get(key).customer_id = Number(id);
          customerMap.get(key).id = Number(id);
        }
      }
    });

    // 2. Process all projects
    const allProjects = [
      ...(this.allCostingProjects || []),
      ...(this.allProcurementProjects || []),
      ...(this.costingData || []),
      ...(this.procurementData || []),
      ...(this.allCustomerData || []),
      ...(this.originalGroupedData || [])
    ];

    allProjects.forEach(p => {
      const cName = p?.customer_name || p?.customerName || p?.selectedVersionData?.customer_name || p?.selectedVersionData?.customerName;
      const cId = p?.customer_id || p?.selectedVersionData?.customer_id || null;
      if (cName && typeof cName === 'string' && cName.trim() && cName.trim() !== 'N/A') {
        const trimmed = cName.trim();
        const key = trimmed.toLowerCase();
        if (!customerMap.has(key)) {
          customerMap.set(key, {
            customerName: trimmed,
            customer_name: trimmed,
            customer_id: cId ? Number(cId) : null,
            id: cId ? Number(cId) : null
          });
        } else if (cId && !customerMap.get(key).customer_id) {
          customerMap.get(key).customer_id = Number(cId);
          customerMap.get(key).id = Number(cId);
        }
      }
    });

    const mergedList = Array.from(customerMap.values())
      .sort((a, b) => a.customerName.localeCompare(b.customerName));

    this.allCustomerDetails = mergedList;
    this.allCustomerData = mergedList;
  }

  syncProjectNameDetails(): void {
    const allProjects = [
      ...(this.allCostingProjects || []),
      ...(this.allProcurementProjects || []),
      ...(this.costingData || []),
      ...(this.procurementData || []),
      ...(this.allCustomerData || []),
      ...(this.originalGroupedData || [])
    ];
    const names = new Set<string>();
    allProjects.forEach(p => {
      const name = p?.projectName || p?.project_name;
      if (name && typeof name === 'string' && name.trim()) {
        names.add(name.trim());
      }
    });
    this.projectNameDetails = Array.from(names).sort((a, b) => a.localeCompare(b));
    if (!this.selectedProjectName) {
      this.filteredProjectNames = [...this.projectNameDetails];
    }
  }


  // Update table rows per page
  updateTableRows() {
    // ⚡ Reset to first page and paginate
    this.currentPage = 1;
    this.paginate();
  }

  paginate() {
    const data = this.groupedProjectData;
    const rows = this.rowsPerPage === 'All' ? data.length : Number(this.rowsPerPage);

    const start = (this.currentPage - 1) * rows;
    const end = this.rowsPerPage === 'All' ? data.length : start + rows;

    this.paginatedData = data.slice(start, end);
  }


  syncCurrentPageToActiveTab(): void {
    if (this.activeTab === 1) {
      this.costingCurrentPage = this.currentPage;
      this.costingRowsPerPage = this.rowsPerPage;
    } else {
      this.procurementCurrentPage = this.currentPage;
      this.procurementRowsPerPage = this.rowsPerPage;
    }
  }

  nextPage() {
    const total = this.getTotalPagesForTab();
    if (this.currentPage < total) {
      this.currentPage++;
      this.syncCurrentPageToActiveTab();
      if (this.isAnyFilterActive()) {
        this.paginateFilteredData();
      } else {
        const stage = this.activeTab === 1 ? 'costing' : 'procurement';
        this.getAllProjectData(stage);
      }
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.syncCurrentPageToActiveTab();
      if (this.isAnyFilterActive()) {
        this.paginateFilteredData();
      } else {
        const stage = this.activeTab === 1 ? 'costing' : 'procurement';
        this.getAllProjectData(stage);
      }
    }
  }

  firstPage() {
    if (this.currentPage > 1) {
      this.currentPage = 1;
      this.syncCurrentPageToActiveTab();
      if (this.isAnyFilterActive()) {
        this.paginateFilteredData();
      } else {
        const stage = this.activeTab === 1 ? 'costing' : 'procurement';
        this.getAllProjectData(stage);
      }
    }
  }

  lastPage() {
    const total = this.getTotalPagesForTab();
    if (this.currentPage < total && total > 0) {
      this.currentPage = total;
      this.syncCurrentPageToActiveTab();
      if (this.isAnyFilterActive()) {
        this.paginateFilteredData();
      } else {
        const stage = this.activeTab === 1 ? 'costing' : 'procurement';
        this.getAllProjectData(stage);
      }
    }
  }

  goToPage(page: number | string): void {
    const pageNum = Number(page);
    const totalPages = this.getTotalPagesForTab();
    if (!isNaN(pageNum) && pageNum >= 1 && (totalPages <= 0 || pageNum <= totalPages) && pageNum !== this.currentPage) {
      this.currentPage = pageNum;
      this.syncCurrentPageToActiveTab();
      if (this.isAnyFilterActive()) {
        this.paginateFilteredData();
      } else {
        const stage = this.activeTab === 1 ? 'costing' : 'procurement';
        this.getAllProjectData(stage);
      }
    }
  }

  jumpToPage(customVal?: string): void {
    const val = customVal !== undefined ? customVal : this.jumpPageInput;
    const page = parseInt(String(val).trim(), 10);
    const totalPages = this.getTotalPagesForTab();
    if (!isNaN(page)) {
      let targetPage = page;
      if (targetPage < 1) targetPage = 1;
      if (totalPages > 0 && targetPage > totalPages) targetPage = totalPages;
      this.jumpPageInput = '';
      this.goToPage(targetPage);
    }
  }

  jumpByPages(direction: number): void {
    const totalPages = this.getTotalPagesForTab();
    let targetPage = this.currentPage + direction;
    if (targetPage < 1) targetPage = 1;
    if (totalPages > 0 && targetPage > totalPages) targetPage = totalPages;
    if (targetPage !== this.currentPage) {
      this.goToPage(targetPage);
    }
  }

  onPageSizeChange(): void {
    this.currentPage = 1;
    this.syncCurrentPageToActiveTab();
    if (this.isAnyFilterActive()) {
      this.paginateFilteredData();
    } else {
      const stage = this.activeTab === 1 ? 'costing' : 'procurement';
      this.getAllProjectData(stage);
    }
  }

  // ========== TAB-RELATED METHODS ==========

  // Method to set the active tab
  setActiveTab(tabNumber: number): void {
    if (this.activeTab === tabNumber) return;
    console.log(`📌 Switching from Tab ${this.activeTab} to Tab ${tabNumber}`);
    
    this.activeTab = tabNumber;
    
    if (this.isAnyFilterActive()) {
      this.currentPage = 1;
      this.applyAllFilters();
      return;
    }

    if (this.activeTab === 1) {
      this.currentPage = this.costingCurrentPage || 1;
      this.rowsPerPage = this.costingRowsPerPage || 10;
      this.totalProjectsCount = this.costingTotalCount;
    } else {
      this.currentPage = this.procurementCurrentPage || 1;
      this.rowsPerPage = this.procurementRowsPerPage || 10;
      this.totalProjectsCount = this.procurementTotalCount;
    }

    const stage = this.activeTab === 1 ? 'costing' : 'procurement';
    this.getAllProjectData(stage);
  }

  // Filter data based on current stage and populate tab-specific data
  filterAndDisplayTabData(): void {
    if (this.activeTab === 1) {
      this.currentTabData = this.costingData;
      this.currentPage = this.costingCurrentPage;
      this.rowsPerPage = this.costingRowsPerPage;
      this.totalProjectsCount = this.costingTotalCount;
    } else {
      this.currentTabData = this.procurementData;
      this.currentPage = this.procurementCurrentPage;
      this.rowsPerPage = this.procurementRowsPerPage;
      this.totalProjectsCount = this.procurementTotalCount;
    }
    this.paginatedData = [...this.currentTabData];
    this.updateCardCounts();
  }

  // Restore navigation state after returning from Project View
  restoreNavigationState(navigationState: any): void {
    if (!navigationState || this.restoredState) {
      return;
    }

    console.log('🔄 Restoring: Tab=' + navigationState.activeTab + 
                ' Page=' + navigationState.currentPage + 
                ' ProjectId=' + navigationState.selectedProjectId);
    
    // Restore active tab
    const restoredTab = navigationState.activeTab;
    if (restoredTab && restoredTab !== this.activeTab) {
      this.activeTab = restoredTab;
    }
    
    // Restore pagination state (for the active tab)
    if (navigationState.currentPage) {
      if (this.activeTab === 1) {
        this.costingCurrentPage = navigationState.currentPage;
        this.currentPage = this.costingCurrentPage;
        if (navigationState.rowsPerPage) {
          this.costingRowsPerPage = navigationState.rowsPerPage;
          this.rowsPerPage = this.costingRowsPerPage;
        }
      } else if (this.activeTab === 2) {
        this.procurementCurrentPage = navigationState.currentPage;
        this.currentPage = this.procurementCurrentPage;
        if (navigationState.rowsPerPage) {
          this.procurementRowsPerPage = navigationState.rowsPerPage;
          this.rowsPerPage = this.procurementRowsPerPage;
        }
      }
    }
    
    // Restore highlighted row
    if (navigationState.selectedProjectId) {
      this.highlightedProjectId = navigationState.selectedProjectId;
      console.log('✅ Row highlighted for project ID:', this.highlightedProjectId);
    }
    
    this.restoredState = true;
    const stage = this.activeTab === 1 ? 'costing' : 'procurement';
    this.getAllProjectData(stage);
  }

  // Update rows for active tab
  updateTableRowsForTabs(): void {
    if (this.isAnyFilterActive()) {
      this.paginateFilteredData();
      return;
    }
    this.onPageSizeChange();
  }

  // Paginate for active tab
  paginateForTabs(): void {
    if (this.isAnyFilterActive()) {
      this.paginateFilteredData();
      return;
    }
    this.paginatedData = [...this.currentTabData];
  }

  // Get total pages for active tab
  getTotalPagesForTab(): number {
    const total = this.getTotalCountForTab();
    if (String(this.rowsPerPage) === 'All') return 1;
    const rows = Number(this.rowsPerPage) || 10;
    if (!total || total <= 0) return 1;
    return Math.ceil(total / rows) || 1;
  }

  // Get start index for active tab
  getStartIndexForTab(): number {
    const total = this.getTotalCountForTab();
    if (!total || total === 0 || this.paginatedData.length === 0) return 0;
    if (String(this.rowsPerPage) === 'All') return 1;
    const rows = Number(this.rowsPerPage) || 10;
    return (this.currentPage - 1) * rows + 1;
  }

  // Get end index for active tab
  getEndIndexForTab(): number {
    const total = this.getTotalCountForTab();
    if (!total || total === 0 || this.paginatedData.length === 0) return 0;
    if (String(this.rowsPerPage) === 'All') return total;
    const rows = Number(this.rowsPerPage) || 10;
    return Math.min(this.currentPage * rows, total);
  }

  getTotalCountForTab(): number {
    if (this.isAnyFilterActive()) {
      return this.matchedCustomerData ? this.matchedCustomerData.length : 0;
    }
    return this.activeTab === 1 ? this.costingTotalCount : this.procurementTotalCount;
  }

  getVisiblePages(): (number | string)[] {
    const totalPages = this.getTotalPagesForTab();
    const current = this.currentPage;

    if (totalPages <= 7) {
      const pages: number[] = [];
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
      return pages;
    }

    if (current <= 4) {
      return [1, 2, 3, 4, 5, '...', totalPages];
    } else if (current >= totalPages - 3) {
      return [1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    } else {
      return [1, '...', current - 1, current, current + 1, '...', totalPages];
    }
  }


  get startIndex(): number {
    const rows = this.rowsPerPage === 'All' ? this.groupedProjectData.length : Number(this.rowsPerPage);
    return (this.currentPage - 1) * rows + 1;
  }

  get endIndex(): number {
    const rows = this.rowsPerPage === 'All' ? this.groupedProjectData.length : Number(this.rowsPerPage);
    return Math.min(this.currentPage * rows, this.groupedProjectData.length);
  }

  get totalPages(): number {
    const rows = this.rowsPerPage === 'All' ? this.groupedProjectData.length : Number(this.rowsPerPage);
    return Math.ceil(this.groupedProjectData.length / rows);
  }
  originalGroupedData: any[] = [];


  // onOpenClickedProject(status: string) {
  //   console.log('openStatusCount', this.openStatusCount, status)
  //   console.log('this.matchedCustomerData', this.matchedCustomerData);
  //   this.paginatedData = structuredClone(this.groupedProjectData)


  //   this.groupedProjectData = this.paginatedData.slice(0, this.openStatusCount)

  //   this.paginatedData = this.groupedProjectData.filter(customer => customer.status === status);

  //   console.log('Matched Customer Data:', this.paginatedData);
  //   this.updateTableRows();


  // }


  // onOverdueClick() {
  //   const overdueProjects = this.getOverdueItems(this.groupedProjectData);  // use grouped data
  //   this.groupedProjectData = [...overdueProjects];  // display these in table
  //   this.overdueCount = overdueProjects.length; // update count if needed
  //   this.updateTableRows();

  //   console.log('Filtered Overdue Projects:', overdueProjects);
  // }

  onOpenClickedProject(status: string) {
    console.log('🔵 Filtering for status:', status);
    this.statusFilter = this.statusFilter === status ? null : status;
    this.applyAllFilters();
  }

  onOverdueClick() {
    this.statusFilter = this.statusFilter === 'Overdue' ? null : 'Overdue';
    this.applyAllFilters();
  }

  onThisMonthClick() {
    this.statusFilter = this.statusFilter === 'ThisMonth' ? null : 'ThisMonth';
    this.applyAllFilters();
  }

  onCompletionFilterClicked(completionRange: string) {
    console.log('📈 Filtering by completion range:', completionRange);
    this.statusFilter = this.statusFilter === completionRange ? null : completionRange;
    this.applyAllFilters();
  }

  getOverdueItems(data: any[]) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return data.filter(item => {
      const ecd = item.selectedVersionData?.expectedCompletionDate || item.expectedCompletionDate;
      if (!ecd) return false;
      const expectedDate = new Date(ecd);
      expectedDate.setHours(0, 0, 0, 0);
      const st = item.selectedVersionData?.status || item.status;
      return expectedDate < today && st === 'Open';
    });
  }

  onSearch(value: any) {
    const term = (value?.target?.value ?? value?.term ?? (typeof value === 'string' ? value : '')).trim();
    this.searchText = term;

    if (!term) {
      this.showAddButton = false;
      return;
    }

    const isCustomerExists = this.allCustomerDetails.some(
      (customer: any) => (customer.customerName || customer.customer_name || '').toLowerCase() === term.toLowerCase()
    );

    // Show the 'Add' button only if there's text and customer doesn't exist
    this.showAddButton = !isCustomerExists;
  }

  onProjectSearch(value: any) {
    this.searchText = value.target.value;

    const isProjectExists = this.allProjectDetails.some(
      (project: any) => project.projectName.toLowerCase() === this.searchText.toLowerCase()
    );
  }

  onSelectProject() {
    this.applyAllFilters();
  }

  onSelectCustomer() {
    this.applyAllFilters();
  }

  onSelectEnginner() {
    this.applyAllFilters();
  }

  onSelectStage(eve: any) {
    this.selectedCurrentStage = eve?.target?.value || '';
    this.applyAllFilters();
  }

  getBaseProjectsForActiveTab(): any[] {
    if (this.activeTab === 1) {
      if (this.allCostingProjects && this.allCostingProjects.length > 0) {
        return this.allCostingProjects;
      }
      return this.costingData || [];
    } else {
      if (this.allProcurementProjects && this.allProcurementProjects.length > 0) {
        return this.allProcurementProjects;
      }
      return this.procurementData || [];
    }
  }

  parseDate(val: any): Date | null {
    if (!val) return null;
    if (val instanceof Date) {
      return isNaN(val.getTime()) ? null : new Date(val.getTime());
    }
    if (typeof val === 'number') {
      const d = new Date(val);
      return isNaN(d.getTime()) ? null : d;
    }
    if (typeof val === 'string') {
      const str = val.trim();
      if (!str) return null;
      const dmy = str.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
      if (dmy) {
        const d = new Date(parseInt(dmy[3], 10), parseInt(dmy[2], 10) - 1, parseInt(dmy[1], 10));
        return isNaN(d.getTime()) ? null : d;
      }
      const ymd = str.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
      if (ymd) {
        const d = new Date(parseInt(ymd[1], 10), parseInt(ymd[2], 10) - 1, parseInt(ymd[3], 10));
        return isNaN(d.getTime()) ? null : d;
      }
      const d = new Date(str);
      return isNaN(d.getTime()) ? null : d;
    }
    return null;
  }

  isAnyFilterActive(): boolean {
    return !!(
      (this.selectedProjectName && this.selectedProjectName.trim()) ||
      (this.selectedCustomerName && this.selectedCustomerName.trim()) ||
      (this.selectedEngineer && String(this.selectedEngineer).trim()) ||
      (this.selectedCurrentStage && this.selectedCurrentStage.trim()) ||
      this.fromExpectedCompletionDate ||
      this.toExpectedCompletionDate ||
      this.fromRfqDate ||
      this.toRfqDate ||
      this.statusFilter
    );
  }

  paginateFilteredData(): void {
    this.currentTabData = this.matchedCustomerData;
    if (String(this.rowsPerPage) === 'All') {
      this.paginatedData = [...this.matchedCustomerData];
    } else {
      const rows = Number(this.rowsPerPage) || 10;
      const startIndex = (this.currentPage - 1) * rows;
      this.paginatedData = this.matchedCustomerData.slice(startIndex, startIndex + rows);
    }
  }

  applyAllFilters() {
    if (!this.isAnyFilterActive()) {
      const stage = this.activeTab === 1 ? 'costing' : 'procurement';
      this.currentPage = this.activeTab === 1 ? (this.costingCurrentPage || 1) : (this.procurementCurrentPage || 1);
      this.getAllProjectData(stage);
      return;
    }

    const baseData = this.getBaseProjectsForActiveTab();
    const searchProj = (this.selectedProjectName || '').trim().toLowerCase();
    const searchCust = (this.selectedCustomerName || '').trim().toLowerCase();
    const engineerId = this.selectedEngineer ? String(this.selectedEngineer).trim() : '';
    const stageFilter = (this.selectedCurrentStage || '').trim().toLowerCase();
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    this.matchedCustomerData = baseData.filter(group => {
      const versionData = group.selectedVersionData || group;

      // Project Name filter (partial search / substring)
      if (searchProj) {
        const pName = (group.projectName || versionData.projectName || '').toLowerCase();
        if (!pName.includes(searchProj)) {
          return false;
        }
      }

      // Customer Name filter (case-insensitive substring or exact match)
      if (searchCust) {
        const cName = (group.customer_name || group.customerName || versionData.customer_name || versionData.customerName || '').toLowerCase().trim();
        if (cName !== searchCust && !cName.includes(searchCust)) {
          return false;
        }
      }

      // Engineer filter
      if (engineerId) {
        const assignedId = String(versionData.assigned_to_id ?? group.assigned_to_id ?? '').trim();
        if (assignedId !== engineerId) {
          return false;
        }
      }

      // Current Stage filter
      if (stageFilter) {
        const currentStage = (group.currentstage || versionData.currentstage || '').toLowerCase().trim();
        if (currentStage !== stageFilter) {
          return false;
        }
      }

      // Status filter from stat cards
      if (this.statusFilter) {
        if (this.statusFilter === 'Open') {
          const s = versionData.status || group.status;
          if (s !== 'Open' && s !== 'In Progress') return false;
        } else if (this.statusFilter === 'Overdue') {
          const ecdVal = versionData.expectedCompletionDate || group.expectedCompletionDate;
          if (!ecdVal) return false;
          const expDate = this.parseDate(ecdVal);
          if (!expDate) return false;
          expDate.setHours(0, 0, 0, 0);
          const s = versionData.status || group.status;
          if (!(expDate < today && s === 'Open')) return false;
        } else if (this.statusFilter === 'ThisMonth') {
          const rfqVal = group.rfqDate || versionData.rfqDate;
          if (!rfqVal) return false;
          const rDate = this.parseDate(rfqVal);
          if (!rDate) return false;
          if (rDate.getMonth() !== today.getMonth() || rDate.getFullYear() !== today.getFullYear()) return false;
        } else if (this.statusFilter === 'lt50') {
          const progress = parseInt(versionData.progress || '0', 10);
          if (progress >= 50) return false;
        } else if (this.statusFilter === '50to75') {
          const progress = parseInt(versionData.progress || '0', 10);
          if (progress < 50 || progress > 75) return false;
        } else if (this.statusFilter === 'gt75') {
          const progress = parseInt(versionData.progress || '0', 10);
          if (progress <= 75) return false;
        }
      }

      // ECD Date range filter
      if (this.fromExpectedCompletionDate || this.toExpectedCompletionDate) {
        const ecdVal = versionData.expectedCompletionDate ||
                       group.expectedCompletionDate ||
                       versionData.expetedCompletionDate ||
                       group.expetedCompletionDate;
        if (!ecdVal) return false;
        const ecdDate = this.parseDate(ecdVal);
        if (!ecdDate) return false;

        let fromECD = this.fromExpectedCompletionDate ? this.parseDate(this.fromExpectedCompletionDate) : null;
        let toECD = this.toExpectedCompletionDate ? this.parseDate(this.toExpectedCompletionDate) : null;
        if (fromECD) fromECD.setHours(0, 0, 0, 0);
        if (toECD) toECD.setHours(23, 59, 59, 999);

        if (fromECD && toECD && fromECD > toECD) {
          const temp = fromECD;
          fromECD = toECD;
          toECD = temp;
          fromECD.setHours(0, 0, 0, 0);
          toECD.setHours(23, 59, 59, 999);
        }

        if (fromECD && ecdDate < fromECD) return false;
        if (toECD && ecdDate > toECD) return false;
      }

      // RFQ Date range filter
      if (this.fromRfqDate || this.toRfqDate) {
        const rfqVal = versionData.rfqDate ||
                       group.rfqDate ||
                       versionData.rfq_date ||
                       group.rfq_date;
        if (!rfqVal) return false;
        const rfqDate = this.parseDate(rfqVal);
        if (!rfqDate) return false;

        let fromRFQ = this.fromRfqDate ? this.parseDate(this.fromRfqDate) : null;
        let toRFQ = this.toRfqDate ? this.parseDate(this.toRfqDate) : null;
        if (fromRFQ) fromRFQ.setHours(0, 0, 0, 0);
        if (toRFQ) toRFQ.setHours(23, 59, 59, 999);

        if (fromRFQ && toRFQ && fromRFQ > toRFQ) {
          const temp = fromRFQ;
          fromRFQ = toRFQ;
          toRFQ = temp;
          fromRFQ.setHours(0, 0, 0, 0);
          toRFQ.setHours(23, 59, 59, 999);
        }

        if (fromRFQ && rfqDate < fromRFQ) return false;
        if (toRFQ && rfqDate > toRFQ) return false;
      }

      return true;
    });

    this.groupedProjectData = this.matchedCustomerData;
    this.currentPage = 1;
    this.paginateFilteredData();
  }


  openModalECD() {
    this.showModalECD = true;
  }

  // Close ECD Modal
  closeModalECD() {
    this.showModalECD = false;
    this.applyAllFilters();
  }

  resetDates() {
    this.fromExpectedCompletionDate = null;
    this.toExpectedCompletionDate = null;
    this.showModalECD = false;
    this.applyAllFilters();
  }

  // Open RFQ Modal
  openModalRFQ() {
    this.showModalRFQ = true;
  }

  // Close RFQ Modal
  closeModalRFQ() {
    this.showModalRFQ = false;
    this.applyAllFilters();
  }

  resetRfqDates() {
    this.fromRfqDate = null;
    this.toRfqDate = null;
    this.showModalRFQ = false;
    this.applyAllFilters();
  }

  onSelectCompletionDate() {
    this.applyAllFilters();
  }


  onDateRangeChange() {
    this.applyAllFilters();
  }
  onSelectMonthRfq() {
    this.matchedCustomerData = this.allCustomerData
      .filter((cus:any) => cus.customerName === this.selectedCustomerName)
      .map((cus:any) => ({
        serialNumber: cus.serialNumber,
        projectName: cus.projectName,
        customerName: cus.customerName,
        rfqDate: cus.rfqDate,
        assignedTo: cus.assignedTo,
        assignedDate: cus.assignedDate,
        expetedCompletionDate: cus.expetedCompletionDate,
        targetLeadTime: cus.targetLeadTime,
        ageing: cus.ageing,
        progress: cus.progress,
        status: cus.status,
        version_id: cus.version_id,
        upload_status: cus.upload_status,
        currentStage: cus.currentStage,
        activeStatus: cus.activeStatus,
      }));
  }

  back() {
    if (this.fromAnalysisManager) {
      this.router.navigate(['/dashboard-manager/analysis']);
      return;
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === 'ESC') {
      return 'by pressing ESC';
    } else if (reason === 'BACKDROP_CLICK') {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openCustomerModel(customerModal: any, prefillName?: string) {
    const nameToPrefill = (prefillName || this.searchText || '').trim();
    if (nameToPrefill) {
      this.customerForm.patchValue({
        _customerFullName: nameToPrefill
      });
      this.searchText = nameToPrefill;
      this.isCustomerNameDuplicate = this.allCustomerDetails.some(
        (customer: any) => (customer.customerName || customer.customer_name || '').toLowerCase() === nameToPrefill.toLowerCase()
      );
    }

    this.customerModalRef = this.modalService.open(customerModal, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg'
    });

    this.customerModalRef.result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
      this.customerModalRef = null;
    }, (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      this.customerModalRef = null;
    });
  }

  closeCustomerModal() {
    if (this.customerModalRef) {
      this.customerModalRef.close('dismissed');
      this.customerModalRef = null;
    }
    this.customerForm.reset();
    this.showAddCustomerButton = false;
    this.isCustomerNameDuplicate = false;
  }

  resetFields() {
    this.selectedProjectName = '';
    this.selectedCustomerName = '';
    this.selectedEngineer = '';
    this.selectedCurrentStage = '';
    this.selectedExpetedCompletionDate = '';
    this.selectedRfqDate = '';
    this.fromExpectedCompletionDate = null;
    this.toExpectedCompletionDate = null;
    this.fromRfqDate = null;
    this.toRfqDate = null;
    this.statusFilter = null;
    this.editProjectRow(null);
    this.currentPage = 1;
    this.syncCurrentPageToActiveTab();
    // Reload data maintaining current tab's stage (lowercase for API)
    const currentStage = this.activeTab === 1 ? 'costing' : 'procurement';
    this.getAllProjectData(currentStage);
  }
  previousStage: string | null = null;

 
  openProjectModel(projectModal: any, customer: any, projectId: any) {

  // Store previous project stage (needed for stage-change logic)
  this.previousStage = customer?.currentstage || null;

  if (customer) {
    this.selectedCustomerId = customer.customer_id;
    this.selectedmatchedCustomerData = customer;
    this.selectedProjectId = customer.project_id;

    // Ensure customer exists in allCustomerDetails so ng-select displays it
    const cName = customer.customer_name || customer.customerName;
    if (cName && !this.allCustomerDetails.some(c => (c.customerName || c.customer_name || '').toLowerCase() === cName.toLowerCase())) {
      this.allCustomerDetails = [
        ...this.allCustomerDetails,
        { customerName: cName, customer_name: cName, customer_id: customer.customer_id || null }
      ].sort((a, b) => a.customerName.localeCompare(b.customerName));
    }
  }

  this.showAddCustomerButton = false;

  this.modalRef = this.modalService.open(projectModal, { 
    ariaLabelledBy: 'modal-basic-title', 
    size: 'lg' 
  });

  this.modalRef.result.then((result) => {
    this.closeResult = `Closed with: ${result}`;
  }, (reason) => {
    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  });

  // ====== EDIT MODE ======
  if (customer) {

    this.patchCustomerData(customer);

    this.onQn123 = {
  q1: customer.q1 == true || customer.q1 == 'true' || customer.q1 == 1 || customer.q1 == 'yes',
  q2: customer.q2 == true || customer.q2 == 'true' || customer.q2 == 1 || customer.q2 == 'yes',
  q3: customer.q3 == true || customer.q3 == 'true' || customer.q3 == 1 || customer.q3 == 'yes',
};


    this.dutyValuePercentage = customer.duty_percentage;

 
    this.showQn2 = this.onQn123.q1;
this.showQn3 = this.onQn123.q2;
this.showDutyInput = this.onQn123.q3;


  } else {

    // ====== ADD MODE ======
    this.selectedCustomerId = null;
    this.selectedmatchedCustomerData = null;
    this.selectedProjectId = null;
    this.showAddButton = false;
    this.searchText = '';

    this.projectForm.reset();
    this.projectForm.patchValue({
      version_id: 1
    });
    this.projectForm.get('version_id')?.disable();

    this.getAllcustomers();

    // Reset Landing Cost fields
    this.onQn123 = { q1: null, q2: null, q3: null };
    this.dutyValuePercentage = null as any;

    this.showQn2 = false;
    this.showQn3 = false;
    this.showDutyInput = false;
  }
}

  patchCustomerData(selectedmatchedCustomerData: any) {

    this.projectForm.patchValue({
      newProjectName: selectedmatchedCustomerData.projectName,
      customerFullName: selectedmatchedCustomerData.customer_name,
      rfqDate: selectedmatchedCustomerData.rfqDate,
      completionDate: selectedmatchedCustomerData.expectedCompletionDate,
      targetLT: selectedmatchedCustomerData.targetLeadTime,
      assignTo: selectedmatchedCustomerData.assigned_to_id,
      currentStage: selectedmatchedCustomerData.currentstage,
      version_id: selectedmatchedCustomerData.version_id

    });
    this.projectForm.get('version_id')?.disable();
  }

  onLandinCost(landinCostModal: any) {
    this.modalRef = this.modalService.open(landinCostModal, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg'
    });

    this.modalRef.result.then((result) => {

      console.log('Received from modal:', result);
      this.closeResult = `Closed with: ${result}`;



    }, (reason) => {
      console.log('Modal dismissed => ', reason);
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
showAddButton: boolean = false;



  closeModal() {

    if (this.modalRef) {
      this.modalRef.close();
      this.showAddCustomerButton = false;
    } else {
      this.modalService.dismissAll();
      this.showAddCustomerButton = false;
    }
    this.modalService.dismissAll();
  }


  onAddNewCustomer(event?: any): void {
    if (!event) {
      this.selectedCustomerId = null;
      this.showAddButton = false;
      return;
    }

    const customerName = typeof event === 'string' ? event : (event?.customerName || event?.customer_name);
    let customerId = typeof event === 'object' ? (event?.customer_id ?? event?.id) : null;

    if (!customerId && customerName) {
      const matched = this.allCustomerDetails.find(
        (c: any) => (c.customerName || c.customer_name || '').trim().toLowerCase() === customerName.trim().toLowerCase()
      );
      if (matched) {
        customerId = matched.customer_id ?? matched.id;
      }
    }

    this.selectedCustomerId = customerId ? Number(customerId) : null;
    this.showAddButton = false;
    this.searchText = '';
    console.log('Customer selected:', customerName, 'ID:', this.selectedCustomerId);
  }

  onCustomerSearch(event: any): void {
    const term = (event?.term ?? event?.target?.value ?? (typeof event === 'string' ? event : '')).trim();
    this.searchText = term;

    if (!term) {
      this.showAddButton = false;
      return;
    }

    const exists = this.allCustomerDetails.some(
      (c: any) => (c.customerName || c.customer_name || '').toLowerCase() === term.toLowerCase()
    );

    this.showAddButton = !exists;
  }

  onCustomerClear(): void {
    this.selectedCustomerId = null;
    this.showAddButton = false;
    this.searchText = '';
    this.projectForm.get('customerFullName')?.setValue(null);
  }

  onSelectProjectName(eve?: any): void {
    this.selectedProjectId = eve?.id;
    console.log('selectedProjectId', this.selectedProjectId);

  }

  enterProject(eve: any): void {
    let enteredProject = eve.target.value.trim(); // Trim to avoid leading/trailing spaces
    this.isProjectNameDuplicate = this.allCustomerData.some(
      (project:any) => project.projectName === enteredProject
    );
  }

  onEnterCustomerName(eve: any): void {
    let enteredCustomer = (eve?.target?.value || '').trim();
    this.isCustomerNameDuplicate = this.allCustomerDetails.some(
      (customer:any) => (customer.customerName || customer.customer_name || '').toLowerCase() === enteredCustomer.toLowerCase()
    );
  }

  save(): void {
     if (this.onQn123.q1 === null) {
    this.notify.info("Please answer Landing Cost question (Q1).");
    return;
  }
  if (this.onQn123.q1 === true && this.onQn123.q2 === null) {
    this.notify.info("Please answer Duties question (Q2).");
    return;
  }
  if (this.onQn123.q2 === true && this.onQn123.q3 === null) {
    this.notify.info("Please answer Duty Value question (Q3).");
    return;
  }
  if (this.onQn123.q3 === true && (!this.dutyValuePercentage || this.dutyValuePercentage <= 0)) {
    this.notify.info("Please enter a valid Duty Value Percentage.");
    return;
  }
    if (!this.selectedProjectId) {
      let enteredProject:any = this.projectForm.value.newProjectName;
      if (this.isProjectNameDuplicate) {
        return; // Prevent saving if duplicate
      }

      // If there's no selected project ID, check for duplicate project name

      if (this.allCustomerData.some((project:any) => project.projectName === enteredProject)) {
        this.notify.info('Project already available, choose a different Project Name.');
        return; // Prevent saving if duplicate project name is found
      }
    }

    // Prevent duplicate API calls
    if (this.isSaving) {
      return;
    }

    // Set a flag to indicate that the save process is in progress
    this.isSaving = true;
    let payload: any;

    if (this.projectForm.valid) {
      // Resolve customer_id if not already resolved
      const currentCustName = this.projectForm.get('customerFullName')?.value;
      if (!this.selectedCustomerId && currentCustName) {
        const found = this.allCustomerDetails.find(
          (c: any) => (c.customerName || c.customer_name || '').trim().toLowerCase() === currentCustName.trim().toLowerCase()
        );
        if (found?.customer_id || found?.id) {
          this.selectedCustomerId = Number(found.customer_id ?? found.id);
        }
      }

      // Insert logic
      if (!this.selectedProjectId) {
        payload = {
          action: "INSERT",
          project_id: 0,
          version_id: 1,
          projectName: this.projectForm.get('newProjectName')?.value,
             procurement_version_id:0,
          // projectNo: this.projectForm.get('projectNo')?.value,
          // description: this.projectForm.get('description')?.value,
          rfqDate: this.projectForm.get('rfqDate')?.value,
          expectedCompletionDate: this.projectForm.get('completionDate')?.value,
          targetLeadTime: Number(this.projectForm.get('targetLT')?.value),
          created_by_id: this.userId,
          created_date: this.currentDate,
          assigned_to_id: Number(this.projectForm.get('assignTo')?.value),
          assigned_date: this.assignDate,
          customer_id: Number(this.selectedCustomerId) || 0,
          ageing: 0,
          progress: "0%",
          status: "Open",
          currentstage: this.projectForm.get('currentStage')?.value,
          activestatus: ""
        };
        this.projectForm.get('version_id')?.disable();
      }

      // Update logic (if selectedProjectId exists)
      if (this.selectedProjectId) {
        payload = {
          action: "UPDATE",
          project_id: this.selectedProjectId,
          version_id: this.selectedmatchedCustomerData.version_id,
          procurement_version_id:0,
          projectName: this.projectForm.get('newProjectName')?.value,
          rfqDate: this.projectForm.get('rfqDate')?.value,
          expectedCompletionDate: this.projectForm.get('completionDate')?.value,
          targetLeadTime: Number(this.projectForm.get('targetLT')?.value),
          created_by_id: this.userId,
          created_date: this.currentDate,
          assigned_to_id: Number(this.projectForm.get('assignTo')?.value),
          assigned_date: this.selectedmatchedCustomerData.assigned_date,
          customer_id: Number(this.selectedCustomerId) || 0,
          ageing: this.selectedmatchedCustomerData.ageing,
          progress: this.selectedmatchedCustomerData.progress,
          status: this.selectedmatchedCustomerData.status,
          currentstage: this.projectForm.get('currentStage')?.value,
          activestatus: this.selectedmatchedCustomerData.activestatus
        };
        this.projectForm.get('version_id')?.disable();
      }
    
    
if (this.previousStage === 'Costing' && 
    this.projectForm.get('currentStage')?.value === 'Procurement') {

  payload.q1 = this.selectedmatchedCustomerData.q1;
  payload.q2 = this.selectedmatchedCustomerData.q2;
  payload.q3 = this.selectedmatchedCustomerData.q3;
  payload.duty_percentage = this.selectedmatchedCustomerData.duty_percentage;
}
else {
  // Use current answers
  payload.q1 = this.onQn123.q1 === true;
  payload.q2 = this.onQn123.q2 === true;
  payload.q3 = this.onQn123.q3 === true;
  payload.duty_percentage = this.onQn123.q3 === true ? this.dutyValuePercentage || 0 : 0;
}




      console.log('Final Payload:', payload);
      console.log('payload', payload);

      // Check if currentStage is being changed to Procurement
      const isChangingToProcurement = 
        this.projectForm.get('currentStage')?.value === 'Procurement' &&
        this.previousStage !== 'Procurement' &&
        this.selectedProjectId; // Only for UPDATE mode, not INSERT

      // If changing to Procurement, use MOVE_TO_PROCUREMENT action and calculate sequential procurement_version_id
      if (isChangingToProcurement) {
        payload.action = "MOVE_TO_PROCUREMENT";
        payload.progress = "0%";
        
        // Calculate next sequential procurement_version_id for this project
        const existingProcurementCount = this.allCustomerData.filter((project: any) => 
          project.project_id === this.selectedProjectId && project.currentstage === 'Procurement'
        ).length;
        payload.procurement_version_id = existingProcurementCount + 1;
        
        console.log('🔄 MOVE_TO_PROCUREMENT - Sequential Procurement Version:', payload.procurement_version_id, 'version_id:', payload.version_id, 'with payload:', payload);
      } else {
        // Set procurement_version_id based on current stage
        const currentStage = this.projectForm.get('currentStage')?.value;
        payload.procurement_version_id = currentStage === 'Procurement' ? 1 : 0;
      }

      // API call to save data
      this.masterService.manage_projects(payload).pipe(
        catchError((error) => {
          console.error('Error saving data:', error);
          this.notify.danger('An error occurred while saving the project data. Please try again.');
          return of(null); // Return a fallback observable
        })
      ).subscribe({
        next: (response) => {
          if (response) {
            console.log('Project saved successfully:', response);
            this.notify.success('Project saved successfully.');
            this.projectForm.reset();
            this.closeModal();
            // Reload data maintaining current tab's stage (lowercase for API)
            const currentStage = this.activeTab === 1 ? 'costing' : 'procurement';
            this.getAllProjectData(currentStage);
          }
        },
        error: (error) => {
          console.error('Unexpected error:', error);
        },
        complete: () => {
          this.isSaving = false;
          this.closeModal();
          this.projectForm.reset();
        }
      });
    } else {
      this.projectForm.markAllAsTouched();
      this.notify.info('Please fill in all required fields.');
      console.log('Form is invalid');
      this.isSaving = false;
    }
  }



  getThisMonthProjects() {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();

    const dataToFilter = this.getBaseProjectsForActiveTab();

    this.thisMonthProjects = dataToFilter.filter(group => {
      const rDate = group.rfqDate || group.selectedVersionData?.rfqDate;
      if (!rDate) return false;
      const rfqDate = new Date(rDate);
      return rfqDate.getMonth() === currentMonth && rfqDate.getFullYear() === currentYear;
    });

    console.log("This Month Projects:", this.thisMonthProjects);
  }


  groupProjects(data: any[]): any[] {
    const map = new Map();
    data.forEach((item: any) => {
      const stageVal = item.currentstage || item.currentStage || 'Costing';
      const key = `${item.project_id}_${stageVal}`; // Group by project AND stage
      const custName = item.customer_name || item.customerName || 'N/A';
      
      if (!map.has(key)) {
        const processedProgress = item.upload_status?.toLowerCase() === 'new' || item.upload_status?.toLowerCase() === 'inprogress' ? '0%' : item.progress;
        
        map.set(key, {
          ...item,
          customer_name: custName,
          customerName: custName,
          // Costing version management
          versions: item.version_ids || [item.version_id],
          versionDetails: [{
            ...item,
            customer_name: custName,
            customerName: custName,
            progress: processedProgress,
            version_id: item.version_id
          }],
          selectedVersionData: {
            ...item,
            customer_name: custName,
            customerName: custName,
            progress: processedProgress,
            version_id: item.version_id
          },
          // Procurement version management
          procurementVersions: item.procurement_version_ids || (String(stageVal).toLowerCase() === 'procurement' ? [item.procurement_version_id || 0] : []),
          procurementVersionDetails: (item.procurement_version_ids && item.procurement_version_ids.length > 0) || String(stageVal).toLowerCase() === 'procurement' ? [{
            ...item,
            customer_name: custName,
            customerName: custName,
            progress: processedProgress,
            procurement_version_id: item.procurement_version_id || 0
          }] : [],
          selectedProcurementVersionData: (item.procurement_version_ids && item.procurement_version_ids.length > 0) || String(stageVal).toLowerCase() === 'procurement' ? {
            ...item,
            customer_name: custName,
            customerName: custName,
            progress: processedProgress,
            procurement_version_id: item.procurement_version_id || 0
          } : null
        });
      } else {
        const existing = map.get(key);
        const processedProgress = item.upload_status?.toLowerCase() === 'new' || item.upload_status?.toLowerCase() === 'inprogress' ? '0%' : item.progress;
        
        const isCosting = String(stageVal).toLowerCase() === 'costing' || (item.version_ids && item.version_ids.length > 0);
        const isProcurement = String(stageVal).toLowerCase() === 'procurement' || (item.procurement_version_ids && item.procurement_version_ids.length > 0);
        
        if (isCosting) {
          if (!existing.versions.includes(item.version_id)) {
            existing.versions.push(item.version_id);
          }
          if (!existing.versionDetails.find((v: any) => v.version_id === item.version_id)) {
            existing.versionDetails.push({
              ...item,
              customer_name: custName,
              customerName: custName,
              progress: processedProgress,
              version_id: item.version_id
            });
          }
        } else if (isProcurement) {
          const procVerId = item.procurement_version_id || 0;
          if (!existing.procurementVersions.includes(procVerId)) {
            existing.procurementVersions.push(procVerId);
          }
          if (!existing.procurementVersionDetails.find((v: any) => v.procurement_version_id === procVerId)) {
            existing.procurementVersionDetails.push({
              ...item,
              customer_name: custName,
              customerName: custName,
              progress: processedProgress,
              procurement_version_id: procVerId
            });
          }
        }
      }
    });

    // Sort versions descending and set selectedVersionData to latest
    const groups = Array.from(map.values());
    groups.forEach(group => {
      group.versions.sort((a: number, b: number) => b - a);
      group.procurementVersions.sort((a: number, b: number) => b - a);

      if (group.versions.length > 0) {
        const latestVersionId = group.versions[0];
        const latestVersion = group.versionDetails.find((v: any) => v.version_id === latestVersionId);
        if (latestVersion) {
          group.selectedVersionData = { ...latestVersion };
        }
      }

      if (group.procurementVersions.length > 0) {
        const latestProcVersionId = group.procurementVersions[0];
        const latestProcVersion = group.procurementVersionDetails.find((v: any) => v.procurement_version_id === latestProcVersionId);
        if (latestProcVersion) {
          group.selectedProcurementVersionData = { ...latestProcVersion };
          group.selectedVersionData = { ...latestProcVersion };
        }
      }
    });

    return groups;
  }

  fetchStageCounts(): void {
    const costingPayload = {
      action: "SELECT_BY_CREATED_USERID",
      created_by_id: Number(this.userId),
      currentstage: 'costing',
      limit: 100000,
      offset: 0
    };
    this.masterService.manage_projects(costingPayload).subscribe({
      next: (res: any) => {
        if (res?.data && res.status === 'success') {
          const totalFromApi = res.total_count ?? res.total ?? res.count ?? res.total_records;
          this.costingTotalCount = (totalFromApi !== undefined && totalFromApi !== null && !isNaN(Number(totalFromApi)))
            ? Number(totalFromApi)
            : res.data.length;
          if (this.activeTab === 1) {
            this.totalProjectsCount = this.costingTotalCount;
          }
          const rawData = Array.isArray(res.data) ? res.data : [];
          this.allCostingProjects = this.groupProjects(rawData);
          const nonCosting = this.allCustomerData.filter((d: any) => d.currentstage !== 'costing');
          this.allCustomerData = [...res.data, ...nonCosting];
          this.syncProjectNameDetails();
          this.syncCustomerDropdown(this.allCustomerDetails || []);
          this.updateCardCounts();
          console.log('📊 Manager Stage count loaded - Costing:', this.costingTotalCount);
          this.cdRef.detectChanges();
        }
      },
      error: (err: any) => console.error('Error fetching manager costing count:', err)
    });

    const procurementPayload = {
      action: "SELECT_BY_CREATED_USERID",
      created_by_id: Number(this.userId),
      currentstage: 'procurement',
      limit: 100000,
      offset: 0
    };
    this.masterService.manage_projects(procurementPayload).subscribe({
      next: (res: any) => {
        if (res?.data && res.status === 'success') {
          const totalFromApi = res.total_count ?? res.total ?? res.count ?? res.total_records;
          this.procurementTotalCount = (totalFromApi !== undefined && totalFromApi !== null && !isNaN(Number(totalFromApi)))
            ? Number(totalFromApi)
            : res.data.length;
          if (this.activeTab === 2) {
            this.totalProjectsCount = this.procurementTotalCount;
          }
          const rawData = Array.isArray(res.data) ? res.data : [];
          this.allProcurementProjects = this.groupProjects(rawData);
          const nonProc = this.allCustomerData.filter((d: any) => d.currentstage !== 'procurement');
          this.allCustomerData = [...nonProc, ...res.data];
          this.syncProjectNameDetails();
          this.syncCustomerDropdown(this.allCustomerDetails || []);
          this.updateCardCounts();
          console.log('📊 Manager Stage count loaded - Procurement:', this.procurementTotalCount);
          this.cdRef.detectChanges();
        }
      },
      error: (err: any) => console.error('Error fetching manager procurement count:', err)
    });
  }

  loadBothStages(onComplete?: () => void): void {
    this.isRefresh = true;
    let costingGroupedData: any[] = [];
    let procurementGroupedData: any[] = [];
    let stagesLoaded = 0;

    const onStageComplete = () => {
      stagesLoaded++;
      if (stagesLoaded === 2) {
        if (this.activeTab === 1) {
          this.matchedCustomerData = costingGroupedData;
          this.currentTabData = costingGroupedData;
          this.paginatedData = costingGroupedData;
          this.currentPage = this.costingCurrentPage || 1;
          this.rowsPerPage = this.costingRowsPerPage || 10;
          this.totalProjectsCount = this.costingTotalCount;
        } else {
          this.matchedCustomerData = procurementGroupedData;
          this.currentTabData = procurementGroupedData;
          this.paginatedData = procurementGroupedData;
          this.currentPage = this.procurementCurrentPage || 1;
          this.rowsPerPage = this.procurementRowsPerPage || 10;
          this.totalProjectsCount = this.procurementTotalCount;
        }

        this.groupedProjectData = [...this.matchedCustomerData];
        this.originalGroupedData = this.groupedProjectData;

        this.syncProjectNameDetails();
        this.syncCustomerDropdown(this.allCustomerDetails || []);
        this.updateCardCounts();
        this.receiveData();

        this.isRefresh = false;

        if (onComplete) {
          onComplete();
        }
        this.cdRef.detectChanges();
      }
    };

    // Trigger stage counts in parallel to ensure true total count is available upfront
    this.fetchStageCounts();

    // Load Costing Stage
    const costingLimit = Number(this.costingRowsPerPage) || 10;
    const costingOffset = (Math.max(1, this.costingCurrentPage) - 1) * costingLimit;
    const costingPayload: any = {
      action: "SELECT_BY_CREATED_USERID",
      created_by_id: Number(this.userId),
      currentstage: 'costing',
      limit: costingLimit,
      offset: costingOffset
    };

    this.masterService.manage_projects(costingPayload).subscribe({
      next: (result: any) => {
        if (result && result.status === 'success' && result.data) {
          const rawData = Array.isArray(result.data) ? result.data : [];
          costingGroupedData = this.groupProjects(rawData);
          this.costingData = costingGroupedData;
          if (!this.allCostingProjects || this.allCostingProjects.length === 0) {
            this.allCostingProjects = costingGroupedData;
          }
          const totalFromApi = result.total_count ?? result.total ?? result.count ?? result.total_records ?? result.totalProjects ?? result.totalCount ?? result.pagination?.total_records ?? result.pagination?.total;
          if (totalFromApi !== undefined && totalFromApi !== null && !isNaN(Number(totalFromApi))) {
            this.costingTotalCount = Number(totalFromApi);
          } else if (rawData.length < costingLimit && rawData.length > 0) {
            this.costingTotalCount = costingOffset + rawData.length;
          } else if (!this.costingTotalCount || this.costingTotalCount <= 0) {
            this.costingTotalCount = costingOffset + rawData.length;
          }
        }
        onStageComplete();
      },
      error: (error) => {
        console.error('Error loading costing data:', error);
        onStageComplete();
      }
    });

    // Load Procurement Stage
    const procurementLimit = Number(this.procurementRowsPerPage) || 10;
    const procurementOffset = (Math.max(1, this.procurementCurrentPage) - 1) * procurementLimit;
    const procurementPayload: any = {
      action: "SELECT_BY_CREATED_USERID",
      created_by_id: Number(this.userId),
      currentstage: 'procurement',
      limit: procurementLimit,
      offset: procurementOffset
    };

    this.masterService.manage_projects(procurementPayload).subscribe({
      next: (result: any) => {
        if (result && result.status === 'success' && result.data) {
          const rawData = Array.isArray(result.data) ? result.data : [];
          procurementGroupedData = this.groupProjects(rawData);
          this.procurementData = procurementGroupedData;
          if (!this.allProcurementProjects || this.allProcurementProjects.length === 0) {
            this.allProcurementProjects = procurementGroupedData;
          }
          const totalFromApi = result.total_count ?? result.total ?? result.count ?? result.total_records ?? result.totalProjects ?? result.totalCount ?? result.pagination?.total_records ?? result.pagination?.total;
          if (totalFromApi !== undefined && totalFromApi !== null && !isNaN(Number(totalFromApi))) {
            this.procurementTotalCount = Number(totalFromApi);
          } else if (rawData.length < procurementLimit && rawData.length > 0) {
            this.procurementTotalCount = procurementOffset + rawData.length;
          } else if (!this.procurementTotalCount || this.procurementTotalCount <= 0) {
            this.procurementTotalCount = procurementOffset + rawData.length;
          }
        }
        onStageComplete();
      },
      error: (error) => {
        console.error('Error loading procurement data:', error);
        onStageComplete();
      }
    });
  }

  getAllProjectData(currentStage: string = 'costing') {
    const isCosting = currentStage.toLowerCase() === 'costing';
    const limit = String(this.rowsPerPage) === 'All' ? 100000 : (Number(this.rowsPerPage) || 10);
    const offset = (Math.max(1, this.currentPage) - 1) * (String(this.rowsPerPage) === 'All' ? 0 : (Number(this.rowsPerPage) || 10));

    let payloadData: any = {
      action: "SELECT_BY_CREATED_USERID",
      created_by_id: Number(this.userId),
      currentstage: currentStage,
      limit: limit,
      offset: offset
    };

    if (this.selectedProjectName && this.selectedProjectName.trim()) {
      payloadData.projectName = this.selectedProjectName.trim();
    }

    this.isRefresh = true;
    console.log('manage_projects manager payload => ', payloadData);
    this.masterService.manage_projects(payloadData).subscribe({
      next: (result: any) => {
        console.log('manage_projects manager response => ', result);
        this.isRefresh = false;

        if (result && result.status === 'success' && result.data) {
          const rawData = Array.isArray(result.data) ? result.data : [];
          const totalFromApi = result.total_count ?? result.total ?? result.count ?? result.total_records ?? result.totalProjects ?? result.totalCount ?? result.pagination?.total_records ?? result.pagination?.total;

          const grouped = this.groupProjects(rawData);
          this.matchedCustomerData = grouped;
          this.groupedProjectData = grouped;
          this.currentTabData = [...grouped];
          this.paginatedData = [...grouped];

          if (isCosting) {
            this.costingData = grouped;
            if (!this.allCostingProjects || this.allCostingProjects.length === 0) {
              this.allCostingProjects = grouped;
            }
            if (totalFromApi !== undefined && totalFromApi !== null && !isNaN(Number(totalFromApi))) {
              this.costingTotalCount = Number(totalFromApi);
            } else if (rawData.length < limit && rawData.length > 0) {
              this.costingTotalCount = offset + rawData.length;
            } else if (!this.costingTotalCount || this.costingTotalCount <= 0) {
              this.costingTotalCount = offset + rawData.length;
            }
            if (!this.isAnyFilterActive()) {
              this.totalProjectsCount = this.costingTotalCount;
            }
          } else {
            this.procurementData = grouped;
            if (!this.allProcurementProjects || this.allProcurementProjects.length === 0) {
              this.allProcurementProjects = grouped;
            }
            if (totalFromApi !== undefined && totalFromApi !== null && !isNaN(Number(totalFromApi))) {
              this.procurementTotalCount = Number(totalFromApi);
            } else if (rawData.length < limit && rawData.length > 0) {
              this.procurementTotalCount = offset + rawData.length;
            } else if (!this.procurementTotalCount || this.procurementTotalCount <= 0) {
              this.procurementTotalCount = offset + rawData.length;
            }
            if (!this.isAnyFilterActive()) {
              this.totalProjectsCount = this.procurementTotalCount;
            }
          }

          this.syncProjectNameDetails();
          this.syncCustomerDropdown(this.allCustomerDetails || []);
          this.updateCardCounts();
          this.cdRef.detectChanges();
        } else {
          this.matchedCustomerData = [];
          this.groupedProjectData = [];
          this.currentTabData = [];
          this.paginatedData = [];
          if (isCosting) {
            this.costingTotalCount = 0;
            this.totalProjectsCount = 0;
          } else {
            this.procurementTotalCount = 0;
            this.totalProjectsCount = 0;
          }
          this.cdRef.detectChanges();
        }
      },
      error: (err: any) => {
        this.isRefresh = false;
        console.error('Error: Unable to retrieve project data', err);
        this.notify.danger('There was an issue retrieving the project data. Please try again.');
      }
    });
  }
  calculateProgress(data: any[]): string {
    const totalRows = data.length;
    if (totalRows === 0) return '0';

    const validSupplierCount = data.filter(
      item => item.supplier && item.supplier !== 'N/A'
    ).length;

    const progress = (validSupplierCount / totalRows) * 100;
    return progress.toFixed(2);
  }
  groupProjectsByVersion(data: any[]) {
    const map = new Map();
    const sortedData = data.sort((a, b) => {
      const dateA = new Date(a.created_date).getTime();
      const dateB = new Date(b.created_date).getTime();
      return dateB - dateA;
    });

    sortedData.forEach(item => {
      const key = `${item.projectName}_${item.rfqDate}_${item.assigned_date}_${item.expectedCompletionDate}`;

      if (!map.has(key)) {
        map.set(key, {
          ...item,
          versions: [item.version_id],
          versionDetails: [item],
          selectedVersionData: item
        });
      } else {
        const existing = map.get(key);
        existing.versions.push(item.version_id);
        existing.versionDetails.push(item);
      }
    });


    this.groupedProjectData = Array.from(map.values());
  }

  onVersionChange(event: any, group: any) {
    const selectedVersionId = Number(event.target.value);
    console.log('🔍 Costing Version Change - selectedVersionId:', selectedVersionId);
    
    let selected = group.versionDetails.find((v: any) => v.version_id === selectedVersionId);
    
    if (!selected) {
      selected = this.allCustomerData.find((v: any) => 
        v.project_id === group.project_id && 
        v.currentstage === group.currentstage &&
        v.version_id === selectedVersionId
      );
    }

    if (selected) {
      group.selectedVersionData = { ...selected };
      this.selectedVersionId = selectedVersionId;
      sessionStorage.setItem('version_id', String(selectedVersionId));
      sessionStorage.setItem('project_id', String(group.project_id));
      console.log('✅ Updated selectedVersionData (Costing):', group.selectedVersionData);
      this.cdRef.detectChanges();
    }
  }

  onProcurementVersionChange(event: any, group: any) {
    const selectedProcurementVersionId = Number(event.target.value);
    console.log('🔍 Procurement Version Change - selectedProcurementVersionId:', selectedProcurementVersionId);
    
    let selected = group.procurementVersionDetails.find((v: any) => v.procurement_version_id === selectedProcurementVersionId);
    
    if (!selected) {
      selected = this.allCustomerData.find((v: any) => 
        v.project_id === group.project_id && 
        v.currentstage === group.currentstage &&
        v.procurement_version_id === selectedProcurementVersionId
      );
    }

    if (selected) {
      const updatedData = {
        ...selected,
        procurement_version_id: selectedProcurementVersionId,
        progress: selected.progress || '0%',
        status: selected.status || 'N/A',
        upload_status: selected.upload_status || 'N/A',
        currentstage: selected.currentstage || group.currentstage
      };
      
      group.selectedProcurementVersionData = updatedData;
      group.selectedVersionData = updatedData;
      
      sessionStorage.setItem('procurement_version_id', String(selectedProcurementVersionId));
      sessionStorage.setItem('project_id', String(group.project_id));
      console.log('✅ Updated selectedVersionData (Procurement):', group.selectedVersionData);
      this.cdRef.detectChanges();
    }
  }

  saveCustomer() {
    if (this.customerForm.invalid || this.isCustomerNameDuplicate) {
      this.customerForm.markAllAsTouched();
      this.notify.info('Please fill in all required customer fields.');
      return;
    }

    // Prevent duplicate API calls
    if (this.isSaving) {
      return;
    }

    this.isSaving = true;

    const newCustomerName = (this.customerForm.get('_customerFullName')?.value || '').trim();
    const payload = {
      customerName: newCustomerName,
      city: (this.customerForm.get('city')?.value || '').trim(),
      state: (this.customerForm.get('state')?.value || '').trim(),
      country: (this.customerForm.get('country')?.value || '').trim(),
      gstNumber: (this.customerForm.get('gstNumber')?.value || '').trim(),
    };

    console.log('payload', payload);

    // API call to save data
    this.masterService.create_customers(payload).pipe(
      catchError((error) => {
        console.error('Error saving data:', error);
        this.notify.danger('An error occurred while saving the customer data. Please try again.');
        this.isSaving = false;
        this.cdRef.detectChanges();
        return of(null);
      })
    ).subscribe({
      next: (response) => {
        this.isSaving = false;
        if (response) {
          console.log('Customer saved successfully:', response);
          this.notify.success('Customer saved successfully.');

          // Extract created ID safely from all possible response formats:
          // Backend returns: { status: 'success', code: 201, record: [{ id: 59, customerName: '...' }] }
          const recordItem = Array.isArray(response?.record)
            ? response.record[0]
            : (response?.record ?? null);
          const dataItem = Array.isArray(response?.data)
            ? response.data[0]
            : (response?.data ?? null);

          const rawId = recordItem?.id ?? recordItem?.customer_id ??
                        dataItem?.id ?? dataItem?.customer_id ??
                        response?.id ?? response?.customer_id ?? null;
          const createdId = rawId ? Number(rawId) : null;

          const createdName = (
            recordItem?.customerName || recordItem?.customer_name ||
            dataItem?.customerName || dataItem?.customer_name ||
            newCustomerName
          ).trim();

          const newEntry = {
            customerName: createdName,
            customer_name: createdName,
            customer_id: createdId,
            id: createdId
          };

          const remaining = (this.allCustomerDetails || []).filter(
            (c: any) => (c.customerName || c.customer_name || '').trim().toLowerCase() !== createdName.toLowerCase()
          );
          this.allCustomerDetails = [...remaining, newEntry].sort((a: any, b: any) =>
            (a.customerName || '').localeCompare(b.customerName || '')
          );

          // Auto-select in projectForm if project modal is open
          this.projectForm.get('customerFullName')?.setValue(createdName);
          this.projectForm.get('customerFullName')?.markAsDirty();
          this.projectForm.get('customerFullName')?.updateValueAndValidity();

          this.selectedCustomerId = createdId;
          this.showAddButton = false;
          this.searchText = '';

          // Reset and close customer modal
          this.customerForm.reset();
          if (this.customerModalRef) {
            this.customerModalRef.close('saved');
            this.customerModalRef = null;
          }
          this.showAddCustomerButton = false;
          this.isCustomerNameDuplicate = false;

          // REFRESH customers from backend and guarantee customer is selected
          this.getAllcustomers(() => {
            if (createdName) {
              const matched = (this.allCustomerDetails || []).find(
                (c: any) => (c.customerName || c.customer_name || '').trim().toLowerCase() === createdName.toLowerCase()
              );
              if (matched) {
                const refreshedId = matched.customer_id ?? matched.id;
                if (refreshedId) {
                  this.selectedCustomerId = Number(refreshedId);
                }
              }
              this.projectForm.get('customerFullName')?.setValue(createdName);
              this.projectForm.get('customerFullName')?.markAsDirty();
              this.projectForm.get('customerFullName')?.updateValueAndValidity();
            }
            this.cdRef.detectChanges();
          });

          this.cdRef.detectChanges();
        }
      },
      error: (error) => {
        this.isSaving = false;
        console.error('Unexpected error saving customer:', error);
        this.cdRef.detectChanges();
      }
    });
  }


  showQn2: boolean = false;
  showQn3: boolean = false;
  
onQn1Change(answer: string) {
  if (answer === 'yes') {
    this.showQn2 = true;
    this.onQn123.q1 = true;
  } else {
    this.showQn2 = false;
    this.showQn3 = false;
    this.onQn123.q1 = false;
    this.onQn123.q2 = null;
    this.onQn123.q3 = null;
    this.dutyValuePercentage = 0;
  }
}

onQn2Change(answer: string) {
  if (answer === 'yes') {
    this.showQn3 = true;
    this.onQn123.q2 = true;
  } else {
    this.showQn3 = false;
    this.onQn123.q2 = false;
    this.onQn123.q3 = null;
    this.dutyValuePercentage = 0;
  }
}

onQn3Change(value: string) {
  if (value === 'export') {
    this.showDutyInput = true;
    this.onQn123.q3 = true;
  } else {
    this.showDutyInput = false;
    this.onQn123.q3 = false;
    this.dutyValuePercentage = 0;
  }
}








  
  saveLandingCost(modal?: any) {
  const payload: any = {};

  if (this.onQn123.q1 === true) {
    payload.landingcost = true;

    if (this.onQn123.q2 === true) {
      payload.dutiesofcalclandingcost = true;

      if (this.onQn123.q3 !== null) {
        payload.dutyvalue = this.onQn123.q3;

        if (this.onQn123.q3 === true && this.dutyValuePercentage !== null) {
          payload.dutyvaluepercentage = this.dutyValuePercentage;
        }
      }
    } else {
      payload.dutiesofcalclandingcost = false;
    }

  } else {
    payload.landingcost = false;
  }

  console.log("Final Payload:", payload);

  if (modal) {
    modal.close(payload);
  } else {
    this.modalService.dismissAll();
  }
}

  // closeLandingCost(){

  // }
  closeLandingCost(modal?: any) {
    this.resetQuestions();
    if (modal) {
      modal.close();  // Close the popup
    }
  }

  resetQuestions() {
    this.showQn2 = false;
    this.showQn3 = false;

  }
  getProgressBarColor(progress: number): string {
    if (progress < 50) {
      return 'warn'; // Light Red for less than 50%
    } else if (progress >= 50 && progress < 100) {
      return 'accent'; // Light Yellow for 50% to 99%
    }
    return 'primary'; // Light Blue for 100%
  }

  getProgressColor(progress: string | number): string {
    // Parse progress to get numeric value
    let progressValue = 0;
    
    if (typeof progress === 'string') {
      progressValue = parseInt(progress.replace('%', ''), 10);
    } else if (typeof progress === 'number') {
      progressValue = progress;
    }

    // Return light color based on progress range
    if (progressValue < 50) {
      return '#FFCDD2'; // Light Red/Pink for <50%
    } else if (progressValue >= 50 && progressValue <= 75) {
      return '#FFF9C4'; // Light Yellow for 50-75%
    } else {
      return '#C8E6C9'; // Light Green for >75%
    }
  }

  editProjectRow(customer: any): void {

    if (customer) {
      this.selectedmatchedCustomerData = customer;
      this.editingRowId = Number(customer.project_id);
    }
  }

  isRowEditing(projectId: number): boolean {
    return this.editingRowId === projectId;
  }


  onChangeAssignTo(event: any, customer: any): void {
    const engineerId = Number(event.target.value);

    // Find the selected engineer
    const selectedEngineer:any = this.engineersData.find((user:any) => user.engineer_id === engineerId);

    if (selectedEngineer) {
      console.log('Selected Engineer Name:', selectedEngineer.engineer_name);

      // Update all rows in matchedCustomerData with the same project_id
      this.matchedCustomerData.forEach(row => {
        if (row.project_id === customer.project_id) {
          // Update the engineer name and assigned ID
          row.engineer_name = selectedEngineer.engineer_name;
          row.assigned_to_id = engineerId;
          row.currentstage = customer.currentstage;
          // this.changedstage = customer.currentstage;

          // Optionally, set a default currentstage if needed
          if (!row.currentstage || row.currentstage.trim() === '') {
            row.currentstage = ''; // Example placeholder
            this.notify.info('Please select stage');
          }
        }
      });

      // Notify the user to select the stage
    }
  }


  onChangeStage(eve: any) {

    let changedtage = eve.target.value
    this.changedstage = changedtage
    console.log('val', changedtage);

  }

  onRowSelect(customer: any) {
    let role:any = sessionStorage.getItem('role');
    const fromProcurement = this.activeTab === 2;

    const customerIndex = this.matchedCustomerData.findIndex(c => c.project_id === customer?.selectedVersionData?.project_id);
    if (customerIndex !== -1) {
      this.matchedCustomerData[customerIndex].version_id = Number(customer?.selectedVersionData?.version_id);
      console.log(this.matchedCustomerData[customerIndex].version_id);
      this.selectedVersionId = Number(customer?.selectedVersionData?.version_id);
      this.selectedProjectId = Number(customer?.selectedVersionData?.project_id);
      this.selectedProjectName = String(customer?.selectedVersionData?.projectName);
      sessionStorage.setItem('project_id', String(this.selectedProjectId));
      sessionStorage.setItem('version_id', String(this.selectedVersionId));
      sessionStorage.setItem('projectName', String(this.selectedProjectName));
      
      if (fromProcurement) {
        const procurementVersionId = Number(customer?.selectedVersionData?.procurement_version_id || 0);
        sessionStorage.setItem('procurement_version_id', String(procurementVersionId));
        sessionStorage.setItem('dashboard_selected_data', JSON.stringify(customer?.selectedVersionData));
        this.menuService.setRole(role);
        
        this.router.navigate(['/project-view'], {
          state: { 
            customerInfo: customer?.selectedVersionData, 
            groupInfo: customer,
            startIndex: this.paginatestartIndex,
            endIndex: this.paginateendIndex,
            currentPage: this.currentPage,
            rowsPerPage: this.rowsPerPage,
            activeTab: this.activeTab,
            selectedProjectId: customer?.selectedVersionData?.project_id,
            selectedVersionId: this.selectedVersionId,
            fromProcurement: true,
            procurementVersionId: procurementVersionId,
            matchedData: this.matchedCustomerData 
          }
        });
      } else {
        this.menuService.setRole(role);
        if (this.selectedVersionId) {
          sessionStorage.setItem('procurement_version_id', '0');
          sessionStorage.setItem('dashboard_selected_data', JSON.stringify(customer?.selectedVersionData));
          this.router.navigate(['/project-view'], {
            state: { 
              customerInfo: customer?.selectedVersionData, 
              groupInfo: customer,
              startIndex: this.paginatestartIndex,
              endIndex: this.paginateendIndex,
              currentPage: this.currentPage,
              rowsPerPage: this.rowsPerPage,
              activeTab: this.activeTab,
              selectedProjectId: customer?.selectedVersionData?.project_id,
              selectedVersionId: this.selectedVersionId,
              fromProcurement: false,
              matchedData: this.matchedCustomerData 
            }
          });
        } else {
          this.notify.info('Please select version_id.')
        }
      }
    }
  }

  openApprovalModal(approvalModal: any, group: any): void {
    this.selectedApprovalProject = group;
    this.approvalReviewComments = '';
    this.showReworkCommentBox = false;
    this.selectedApprovalStatus = 'Approved'; // Reset to Approved default
    this.modalRef = this.modalService.open(approvalModal, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      size: 'md',
    });
  }

  closeApprovalModal(): void {
    this.selectedApprovalProject = null;
    this.approvalReviewComments = '';
    this.showReworkCommentBox = false;

    if (this.modalRef) {
      this.modalRef.close();
      this.modalRef = null;
    } else {
      this.modalService.dismissAll();
    }
  }

  prepareRework(): void {
    this.showReworkCommentBox = true;
  }

  submitApproval(action: 'APPROVE_PROJECT' | 'SEND_FOR_REWORK'): void {
    if (!this.selectedApprovalProject?.selectedVersionData || this.isApprovalSubmitting) {
      return;
    }

    if (action === 'SEND_FOR_REWORK' && !this.approvalReviewComments.trim()) {
      this.notify.info('Please enter comments before sending for rework.');
      return;
    }

    const selectedData = this.selectedApprovalProject.selectedVersionData;
    const payload: any = {
      action,
      project_id: Number(selectedData?.project_id ?? this.selectedApprovalProject?.project_id ?? 0),
      version_id: Number(selectedData?.version_id ?? 0),
      procurement_version_id: Number(selectedData?.procurement_version_id ?? 0),
      projectName: selectedData?.projectName ?? this.selectedApprovalProject?.projectName ?? '',
      created_by_id: Number(selectedData?.created_by_id ?? this.userId ?? 0),
      assigned_to_id: Number(selectedData?.assigned_to_id ?? 0),
      approval_status: selectedData?.approval_status ?? 'Pending',
    };

    if (action === 'SEND_FOR_REWORK') {
      payload.review_comments = this.approvalReviewComments.trim();
    }

    this.isApprovalSubmitting = true;
    this.masterService.manage_projects(payload).subscribe({
      next: (response: any) => {
        if (response?.status === 'success') {
          this.notify.success(
            action === 'APPROVE_PROJECT'
              ? 'Project approved successfully.'
              : 'Project sent for rework successfully.'
          );
          this.closeApprovalModal();
          const currentStage = this.activeTab === 1 ? 'costing' : 'procurement';
          this.getAllProjectData(currentStage);
        } else {
          this.notify.danger(response?.message || 'Unable to process the approval request.');
        }
      },
      error: (error) => {
        console.error('Approval action failed:', error);
        this.notify.danger('Failed to process the approval request.');
      },
      complete: () => {
        this.isApprovalSubmitting = false;
      }
    });
  }

  submitApprovalManager(): void {
    if (!this.selectedApprovalProject?.selectedVersionData || this.isApprovalSubmitting) {
      return;
    }

    if ((this.selectedApprovalStatus === 'Rework Required' || this.selectedApprovalStatus === 'Rejected') && !this.approvalReviewComments.trim()) {
      this.notify.info(`Please enter comments before submitting ${this.selectedApprovalStatus}.`);
      return;
    }

    const selectedData = this.selectedApprovalProject.selectedVersionData;
    
    // Determine the action code to send to the API based on selected status
    let action = 'APPROVE_PROJECT';
    if (this.selectedApprovalStatus === 'Rework Required') {
      action = 'SEND_FOR_REWORK';
    } else if (this.selectedApprovalStatus === 'Rejected') {
      action = 'REJECT_PROJECT';
    }

    const payload: any = {
      action,
      project_id: Number(selectedData?.project_id ?? this.selectedApprovalProject?.project_id ?? 0),
      version_id: Number(selectedData?.version_id ?? 0),
      procurement_version_id: Number(selectedData?.procurement_version_id ?? 0),
      projectName: selectedData?.projectName ?? this.selectedApprovalProject?.projectName ?? '',
      created_by_id: Number(selectedData?.created_by_id ?? this.userId ?? 0),
      assigned_to_id: Number(selectedData?.assigned_to_id ?? 0),
      approval_status: this.selectedApprovalStatus,
    };

    if (this.selectedApprovalStatus === 'Rework Required' || this.selectedApprovalStatus === 'Rejected') {
      payload.review_comments = this.approvalReviewComments.trim();
    }

    this.isApprovalSubmitting = true;
    this.masterService.manage_projects(payload).subscribe({
      next: (response: any) => {
        if (response?.status === 'success') {
          this.notify.success(`Project ${this.selectedApprovalStatus.toLowerCase()} successfully.`);
          this.closeApprovalModal();
          const currentStage = this.activeTab === 1 ? 'costing' : 'procurement';
          this.getAllProjectData(currentStage);
        } else {
          this.notify.danger(response?.message || 'Unable to process the approval request.');
        }
      },
      error: (error) => {
        console.error('Approval action failed:', error);
        this.notify.danger('Failed to process the approval request.');
      },
      complete: () => {
        this.isApprovalSubmitting = false;
      }
    });
  }

  getApprovalStatusLabel(group: any): string {
    return group?.selectedVersionData?.approval_status || 'Pending';
  }

}

